// ** Reducers Imports
import navbar from './navbar'
import layout from './layout'
import auth from './authentication'
import meli from './meli'
import userHelper from './userHelper'
import adminAuditLogs from './adminAuditLogs'
import adminClients from './adminClients'
import adminPostMsg from './adminPostMsg'
import meliUserServices from './meliUserServices'
import userTickets from './userTickets'
import adminTickets from './adminTickets'
import adminBroadcast from './adminBroadcast'

// VUEXY
import todo from '@src/views/apps/todo/store'
import chat from '@src/views/apps/chat/store'
import users from '@src/views/apps/user/store'
import email from '@src/views/apps/email/store'
import invoice from '@src/views/apps/invoice/store'
import calendar from '@src/views/apps/calendar/store'
import ecommerce from '@src/views/apps/ecommerce/store'
import dataTables from '@src/views/tables/data-tables/store'
import permissions from '@src/views/apps/roles-permissions/store'

const mlproReducer = {
  auth,
  navbar,
  layout,
  meli,
  userHelper,
  adminAuditLogs,
  adminClients,
  adminPostMsg,
  meliUserServices,
  userTickets,
  adminTickets,
  adminBroadcast
}

const vuexyReducer = {

  todo,
  chat,
  email,
  users,
  invoice,
  calendar,
  ecommerce,
  dataTables,
  permissions
}

// SIN STORE DE VUEXY
//const rootReducer = Object.assign(mlproReducer)

// CON STORE DE VUEXY
const rootReducer = Object.assign(mlproReducer, vuexyReducer)

export default rootReducer
